import React, { useEffect } from 'react';
import styles from './Error.module.css';
import { Button } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Error = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    navigate('/')
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.title}>
          404
        </div>

        <div className={styles.subtitle}>
          {t('error.subtitle')}
        </div>

        <div className={styles.description}>
          {t('error.description')}
        </div>

        <Button
          className={styles.button}
          fullWidth
          onClick={handleClick}
        >
          {t('return')}
        </Button>
      </div>
    </div>
  )
}

export default Error;
